module.exports = __webpack_public_path__ + "static/media/schools_banner.f44b40ec.webp";